'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVATAR_LOOKUP_PROPTYPES = exports.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = exports.OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = exports.DEFAULT_MAX_UPLOAD_SIZE_MB = exports.DEFAULT_AVATAR_MAPPINGS = exports.API_IDENTIFIER_MAPPINGS = exports.API_KNOWN_VALUE_MAPPINGS = exports.API_KNOWN_KEY_MAPPINGS = exports.DEFAULT_PRODUCT_AVATAR = exports.DEFAULT_CONTACT_AVATAR = exports.DEFAULT_COMPANY_AVATAR = exports.RETINA_MULTIPLIER = exports.AVATAR_SIZES = exports.ICON_SIZES = exports.SIZE_CLASSES = undefined;

var _react = require('react');

var _sizes = require('HubStyleTokens/sizes');

var SIZE_CLASSES = exports.SIZE_CLASSES = {
  responsive: '',
  xs: 'private-avatar--xs',
  sm: 'uiAvatarSmall private-avatar--sm',
  md: 'uiAvatarMedium private-avatar--md',
  lg: 'uiAvatarLarge private-avatar--lg',
  xl: 'uiAvatarXLarge private-avatar--xl'
};

var ICON_SIZES = exports.ICON_SIZES = {
  md: 10,
  lg: 12,
  xl: 18
};

var AVATAR_SIZES = exports.AVATAR_SIZES = {
  xs: parseFloat(_sizes.AVATAR_SIZE_EXTRA_SMALL),
  sm: parseFloat(_sizes.AVATAR_SIZE_SMALL),
  md: parseFloat(_sizes.AVATAR_SIZE_MEDIUM),
  lg: parseFloat(_sizes.AVATAR_SIZE_LARGE),
  xl: parseFloat(_sizes.AVATAR_SIZE_EXTRA_LARGE),
  responsive: 100
};

var RETINA_MULTIPLIER = exports.RETINA_MULTIPLIER = 2;

var DEFAULT_BASE = 'https://static.hsappstatic.net/salesImages/static-1.362/avatars';
var DEFAULT_COMPANY_AVATAR = exports.DEFAULT_COMPANY_AVATAR = DEFAULT_BASE + '/default-company-avatar.png';
var DEFAULT_CONTACT_AVATAR = exports.DEFAULT_CONTACT_AVATAR = DEFAULT_BASE + '/default-avatar.png';
var DEFAULT_PRODUCT_AVATAR = exports.DEFAULT_PRODUCT_AVATAR = DEFAULT_BASE + '/default-product-avatar.png';

var API_KNOWN_KEY_MAPPINGS = exports.API_KNOWN_KEY_MAPPINGS = {
  contact: 'knownContacts',
  company: 'knownCompanies'
};

var API_KNOWN_VALUE_MAPPINGS = exports.API_KNOWN_VALUE_MAPPINGS = {
  contact: {
    primaryIdentifier: 'vid',
    secondaryIdentifier: 'email'
  },
  company: {
    primaryIdentifier: 'companyId',
    secondaryIdentifier: 'domain'
  }
};

var API_IDENTIFIER_MAPPINGS = exports.API_IDENTIFIER_MAPPINGS = {
  contact: 'vids',
  company: 'companyIds',
  vid: 'vids',
  companyId: 'companyIds',
  email: 'emails',
  domain: 'domains',
  enrichmentEmail: 'emails',
  enrichmentDomain: 'domains',
  hubSpotUserEmail: 'hubSpotUserEmails',
  product: 'productIds',
  productId: 'productIds'
};

var DEFAULT_AVATAR_MAPPINGS = exports.DEFAULT_AVATAR_MAPPINGS = {
  contact: DEFAULT_CONTACT_AVATAR,
  vid: DEFAULT_CONTACT_AVATAR,
  email: DEFAULT_CONTACT_AVATAR,
  enrichmentEmail: DEFAULT_CONTACT_AVATAR,
  company: DEFAULT_COMPANY_AVATAR,
  companyId: DEFAULT_COMPANY_AVATAR,
  domain: DEFAULT_COMPANY_AVATAR,
  enrichmentDomain: DEFAULT_COMPANY_AVATAR,
  hubSpotUserEmail: DEFAULT_CONTACT_AVATAR,
  product: DEFAULT_PRODUCT_AVATAR,
  productId: DEFAULT_PRODUCT_AVATAR
};

var DEFAULT_MAX_UPLOAD_SIZE_MB = exports.DEFAULT_MAX_UPLOAD_SIZE_MB = 4;

var OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = exports.OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = {
  contact: 'contacts/vid',
  vid: 'contacts/vid',
  company: 'companies/companyId',
  companyId: 'companies/companyId',
  product: 'products/productId',
  productId: 'products/productId'
};

var OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = exports.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = ['contact', 'vid', 'company', 'companyId', 'product', 'productId'];

var AVATAR_LOOKUP_PROPTYPES = exports.AVATAR_LOOKUP_PROPTYPES = _react.PropTypes.oneOfType([_react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['contact']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  secondaryIdentifier: _react.PropTypes.string,
  fileManagerKey: _react.PropTypes.string,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['company']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  secondaryIdentifier: _react.PropTypes.string,
  fileManagerKey: _react.PropTypes.string,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['vid']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['companyId']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['email']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['domain']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['enrichmentEmail']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['enrichmentDomain']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['hubSpotUserEmail']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired]);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-1.1732/js/Constants.js
// module id = 217
// module chunks = 0